import { get } from 'lodash';

const root = state => get(state, 'UsageState.usageList');

export const getUsageListData = state => get(root(state), 'usageListData', []);
export const getUsageListDataError = state =>
  get(root(state), 'usageListDataError', null);
export const getLoading = state => get(root(state), 'loading', false);
export const getPrintLoading = state => get(root(state), 'printLoading', false);
export const getPrintError = state => get(root(state), 'printError', null);
export const getFromDateMax = state => get(root(state), 'fromDateMax', null);
export const getToDateMin = state => get(root(state), 'toDateMin', null);
export const getDeleteLoadingError = state =>
  get(root(state), 'deleteLoadingError', null);
export const getDeleteSuccessMsg = state =>
  get(root(state), 'deleteSuccessMsg', null);
export const getPrintData = state => get(root(state), 'printData', '');



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/state/UsageList/selectors.js